import Store from './core'

export {
  Store as default
}
